import React from "react";
import { motion } from "framer-motion";
import { Server, Layout, Sparkles } from "lucide-react";
import SectionHeader from "../common/sectionHeader";
import "./styles/engineeringIdentity.css";

const branches = [
	{
		title: "Backend Architecture",
		icon: <Server size={16} />,
		color: "#06b6d4",
		skills: ["Java", "Spring Boot", "REST APIs", "PostgreSQL", "Query Tuning", "2FA / OTP"],
	},
	{
		title: "Full-Stack Development",
		icon: <Layout size={16} />,
		color: "#10b981",
		skills: ["React.js", "Redux", "Node.js", "Express", "Vite", "Responsive UI"],
	},
	{
		title: "AI & Future Trajectory",
		icon: <Sparkles size={16} />,
		color: "#6366f1",
		skills: ["GenAI Applications", "LLMs", "LangChain", "System Design", "Cloud Fundamentals"],
	},
];

const EngineeringIdentity = () => {
	return (
		<section className="identity-section">
			<SectionHeader
				tag="Engineering Identity"
				title="How I Build &"
				highlight="Solve Problems"
				subtitle="Focused on solid backend core, full-stack product completion, and enterprise system reliability."
			/>

			<div className="identity-graph">
				<motion.div 
					className="identity-root-node"
					initial={{ scale: 0.95, opacity: 0 }}
					whileInView={{ scale: 1, opacity: 1 }}
					viewport={{ once: true }}
				>
					SOUMIK SAHA — SOFTWARE ENGINEER
				</motion.div>

				<div className="identity-branches">
					{branches.map((branch, index) => (
						<motion.div
							key={index}
							className="identity-branch-card"
							initial={{ opacity: 0, y: 20 }}
							whileInView={{ opacity: 1, y: 0 }}
							viewport={{ once: true }}
							transition={{ duration: 0.4, delay: index * 0.15 }}
						>
							<div className="branch-title" style={{ color: branch.color }}>
								{branch.icon}
								<span>{branch.title}</span>
							</div>

							<div className="branch-pills">
								{branch.skills.map((skill, idx) => (
									<span key={idx} className="tech-pill">
										{skill}
									</span>
								))}
							</div>
						</motion.div>
					))}
				</div>
			</div>
		</section>
	);
};

export default EngineeringIdentity;
